import styled, { css } from "styled-components";
import { Form, Radio, Avatar, Col, Input, Select, DatePicker } from "antd";
import {
  GhostButtonComponent,
  UnderlineLink,
  PillButton,
  PrimaryButtonComponent,
  DisplayFlex,
  ContentContainer,
  StepFlexRow,
  CustomSelectBox
} from "../../../../../CommonComponents/commonStyles";
import { InputWrapper, CheckboxWrapper } from '../../Step1Setup/styles';

const styles = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.primary};
`;

const fontCommonStyle = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size:  ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
`;

const cursorPointer = css`
  cursor: pointer;
`;


export const Err = styled.div`
  margin-top: -20px;
  ${fontCommonStyle}
  color: ${props => props.theme.fontColors.error};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Errradio = styled.div`
  margin-top: -20px;
  ${fontCommonStyle}
  color: ${props => props.theme.fontColors.error};
  font-weight:  ${props => props.theme.fontWeight.bold};
  letter-spacing: 0.6px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size:  ${props => props.theme.fontSize.secondary};
  }
`;

export const PagesHeadingWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: 1.14;
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h3};
    line-height: ${props => props.theme.lineHeight.secondary};
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;

export const SubHeading = styled.div`
  ${fontCommonStyle}
  line-height: ${props => props.theme.lineHeight.primary};
  max-width: 980px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TabsContent = styled.div`
  line-height: 50px;
  padding: 0 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 15px;
  }
`;

export const TooltipTextwrap = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: 1.43;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.white};
  text-align: center;
  display: flex;
  width: 170px;
  padding: 5px 5px;
`;

export const StepFlexRowMargin = styled(StepFlexRow)`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 30px;
    .ant-col-lg-4 {
      margin-bottom: 20px;
    }
  }
`;

export const FormContainer = styled(Form)`
  &&& {
    margin-top: ${props => props.theme.spacing.margins.YBetween};
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      line-height: 0;
    }
  }
`;

export const RadioButtonWrapper = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
`;

export const LabelWrapper = styled.div`
  ${fontCommonStyle}
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-bottom: 4px;
  margin-top: 34px;
  content: none;
`;

export const PhoneLabelWrap = styled(LabelWrapper)`
  margin-top: 10px;
  margin-bottom: 4px;
`;

export const EmailLabelWrap = styled(LabelWrapper)`
  margin-top: 34px;
  margin-bottom: 20px;
`;

export const LabelWrapperDelivery = styled(PhoneLabelWrap)`
  margin-top: 34px;
`;

export const MainWrapper = styled.div`
  .ant-form-item-label {
    label::after {
      content: none;
    }
  }
`;

export const RadioWrapper = styled.div`
  .ant-radio-inner {
    border-color: ${props => props.theme.border.unchecked};
  }
  .ant-radio-inner::after {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }
`;

export const PrimaryElement = styled.span`
  display: inline-block;
  margin-top: 2px;
`;

export const MailContentWrapper = styled.div`
  .ant-radio-wrapper {
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  ${fontCommonStyle}
  line-height: 1.5;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .ant-radio-inner {
    top: 3px;
    border-color: ${props => props.theme.border.unchecked};
  }
  .ant-radio-inner::after {
    background-color: ${props => props.theme.backgroundColor.primary};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
    font-weight: ${props => props.theme.fontWeight.normal};
    margin-right: ${props => props.theme.fontSize.secondary};
  }
`;

export const MailContentWrapperfirst = styled(MailContentWrapper)`
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
  }
`;

export const Underlinelinks = styled(UnderlineLink)`
  width: auto;
  height: 24px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5 !important;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
    font-size:  ${props => props.theme.fontSize.secondary};
  }
`;

export const InvitePartiesLink = styled(Underlinelinks)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size:  ${props => props.theme.fontSize.secondary};
    display: inline;
    margin-left: 0px;
  }
`;

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: ${props => props.theme.fontSize.secondary};
  background-color: ${props => props.theme.backgroundColor.pill};
  margin: 16px 20px 0px 0;
  &:hover, &:focus {
    color:  ${props => props.theme.colors.primaryColor};
    background: ${props => props.theme.backgroundColor.pill};
    border-color: ${props => props.theme.colors.lightGrey};
  }
`;

export const PillButtonAddressWrap = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 16px
  }
`;

const InvitePartiesButton = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold} !important;
  font-size: ${ props => props.theme.fontSize.heading} !important;
  font-stretch: ${props => props.theme.fontStretch.condensed};
  line-height: ${props => props.theme.lineHeight.normal} !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;

const buttonCommon = css`
  font-family: HelveticaNeue-CondensedBlack !important;
  font-size: 18px !important;
  line-height: 1.67 !important;
  letter-spacing: 1.1px !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;





export const DisplayFlexSpace = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const DisplayFlexSpaceMobile = styled(DisplayFlexSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 16px;
  }
`;

export const SelectTabsWrapper = styled.div`
  .ant-tabs-bar {
    margin: 0;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.border.pill};
    .ant-tabs-nav-container {
      height: 55px !important;
    }
  }
  .ant-tabs-tab:hover {
    color: unset;
  }
  .ant-tabs.ant-tabs-card {
    .ant-tabs-card-bar {
      .ant-tabs-tab {
        margin-right: 0;
        border: none;
        padding-left: 0;
        padding-right: 0;
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        height: 56px;
        border-bottom: 1px solid ${props => props.theme.border.pill};
      }
      .ant-tabs-tab-active {
        border-left: 1px solid ${props => props.theme.border.pill};
        border-right: 1px solid ${props => props.theme.border.pill};
        color: ${props => props.theme.colors.primaryColor};
        border-top: none;
        border-top: 4px solid #006778 !important;
        height: 56px;
        border-bottom: none;
      }
    }
  }
  .ant-tabs-tab {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: 0.6px;
    text-align: center;
    background-color: ${props => props.theme.backgroundColor.layoutLight} !important;
    border-radius: 0 !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      letter-spacing: 0.5px;
    }
  }
`;

export const DivisonCategory = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height: 30px;
  color: ${props => props.theme.fontColors.headingColor};
  padding-top: 40px;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const SubDivisonCategory = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 24px;
  color: ${props => props.theme.fontColors.headingColor};
  padding-top: 15px;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const SelectOptionGenderWrapper = styled.div`
.ant-select-selection {
  .ant-select-arrow {
    i {
      display: block;
    }
  }
} 
.ant-select-arrow {
    color: ${props => props.theme.fontColors.tbody};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.colors.border};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const SelectOptionMainWrapper = styled.div`
  .ant-select-dropdown {
    border: 1px solid ${props => props.theme.colors.border};
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
      border: none;      
      padding: 5px 20px;
    }
    li:hover {
      color: #167f91;
      background-color: #e6f7ff;
    }
  }
  .ant-select-dropdown:after {
    bottom: 0;
  }
`;

export const SelectOptionWrapper = styled.div`
  font-family:  ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.tbody};
  font-size: ${props => props.theme.fontColors.secondary};
  line-height: 2.15;
  padding: 2px 0;
`;

const titleCommmon = css`
  ${fontCommonStyle}
  line-height: 1.25;
  letter-spacing: 0.6px;
`;

export const TitleWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-hieght: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
`;

export const TitleWrapperTitle = styled(TitleWrapper)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
  }
`;

export const ExtraContentWrapper = styled.div`
  ${titleCommmon}
  padding-top: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
`;

export const MiddleName = styled.div`
  color: ${props => props.theme.border.inputBox};
  font-size: 16px;
`;

export const InputWrappercal = styled.div`
  width : 300px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;      
  }
  input,
  .ant-select-selection--single {
    height: ${props => props.height ? props.height : '40px !important'};
  }
  .ant-select-arrow-icon {
    display: none;
  }
  input::placeholder {
    color: #d4d4d4;
  }
  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }
  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.border.inputBox};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};      
    }
  }
  .ant-calendar-picker-input {
    margin-top: 0 !important;
    color : ${props => props.theme.border.inputBox};
  }
`;

export const SelectWrapperGraded = styled(InputWrappercal)`
  .ant-select-selection {
    background: #f2f2f2 !important;
    border: 1px solid #d4d4d4;
  }
  .ant-select-arrow-icon {
    display: block;
  }
  .ant-input {
    border: 1px solid #d4d4d4;
    font-size: 16px;
  }
  .ant-select-selection-selected-value {
    color: ${props => props.theme.fontColors.textColor};
    font-size: 16px;
  }
`;

export const InputWrapperGraded = styled(InputWrappercal)`
  input {
    padding: 0 20px;
  }
  input::placeholder {
    color: #d4d4d4;
  }
  .ant-select-selection-selected-value {
    color: ${props => props.theme.fontColors.textColor};
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }    
  }
  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const SecurityNumWrap = styled.div`
  input {
    height: 45px;
  }
  .ant-input {
    border-radius: 0;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-input-suffix {
    display: none;
  }
`;

export const SpanWrap = styled.span`
  white-space: pre-wrap;
  span {
    display: inline-block;
    vertical-align: top;    
  }
`;

export const Accountpara = styled.span`
  font-family:  ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  margin-Top: 30px;
  height:   24px;
  padding: 0px; 
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    float:left;
    margin-top: 0;
  }  
`;

export const Mandatorytext = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  text-align: right;
  height: 24px;
  padding: 0px; 
  color: ${props => props.theme.fontColors.textColor};
`;

export const Accountparasub = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.textColor};
  padding: 0px;   
  width: 100%;
  display: inline-block;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    line-height: ${props => props.theme.lineHeight.primary};
    float:right;
    width: auto;
  }
`;

export const TitleWrapperPrimary = styled.div`
  margin-top:  ${props => (props.marginTop === undefined) ? "30px" : props.marginTop};
  height: 70px;
  margin-left: 6px;
  ${titleCommmon};
  display: flex;
  align-items: center;
  .ant-radio-wrapper {
    margin-right: 20px;
  }
  .ant-radio-wrapper,
  a {
    margin-top: 0px;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: 0;
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 40px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 16px;
  }
`;

export const TitleWrapperPrimaryAdress = styled(TitleWrapperPrimary)`
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 24px;
    margin-top: 60px;
  }
`;

export const NoResultsWrap = styled.div`
  margin-left: 11px;
`;

export const InputWrapperDrop = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: 38px;
    vertical-align: middle;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      display: flex !important;
      align-items: center;
      height: 100%;
    }
    div {
      font-size: ${props => props.theme.fontSize.primary};
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
  }
  .ant-select-selection__placeholder {
    font-size: ${props => props.theme.fontSize.primary};
    color: #d4d4d4;
    padding: 0 9px;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid #d4d4d4;
  }
  .ant-select-selection {
    box-shadow: none;
  }
  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }
  .ant-select-arrow {
    color: ${props => props.theme.fontColors.tbody};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #d4d4d4;
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const WebTitle = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.17;
  color: ${props => props.theme.fontColors.headingColor}7;
  padding: 0 20px 0 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 0 5px 5px;
  }
  @media only screen and (min-width: 320px) and (max-width: 321px) {
    font-size: 21px;
    padding: 0 0 5px 0px;
  }
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 172px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
    margin-top: 45px;
  }
`;

export const WebAccessHeaderWrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 78px;
  }
`;

export const Align = styled.span`
  display: flex;
  align-items: center;
`;

export const AlignContent = styled.span`
  display: flex;
  align-items: center;
  .ant-checkbox-wrapper {
    margin-bottom: 9px !important;
  }
`;

export const RadioWrappered = styled.div`
  &&& {
  .ant-radio {
    margin-top: -4px;
    }
  }
`
export const DisplayFlexAlign = styled(DisplayFlex)`
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    margin-right: 15px;
    align-items: initial;
  }
`;

export const DisplayFlexSpaceWidth = styled(DisplayFlexSpace)`
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    align-items: center;
  }
`;

export const WebAccessInfoWrapper = styled.div`
  .ant-collapse-item {
    background: ${props => props.theme.colors.white};
    border-bottom: none;
  }
  .ant-collapse-content {
    border-radius: 0 !important;
    .ant-collapse-content-box {
      padding: 0 32px 6px;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0 20px 6px;
      }
    }
  }
  .ant-collapse-content {
    border-top: none;
  }
  .ant-collapse {
    border-radius: 0;
    border-bottom: 1px solid #d9d9d9;
  }
  margin-bottom: 50px;
  margin-top: 16px;
`;

export const ExpandWrap = styled.div`
  margin: 5px 14px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 4px 0 0;
  }
`;

export const AdvisoryFormWrapper = styled.div`
  .ant-form {
    margin-top: 20px !important;
  }
`;

export const FlexWrap = styled.div`
  display: flex;
  align-items: baseline;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
  }
`

export const EmailWrapper = styled.div`
  .ant-checkbox-wrapper {
    margin-top: 8px;
    .ant-checkbox-inner {
      width: 15px;
      height: 15px;
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${props => props.theme.backgroundColor.primaryColor};
        border-color: ${props => props.theme.colors.border};
      }
    }
  }
`;

export const EmailTitleWrapper = styled(TitleWrapper)`
  margin-right: 20px;
`;

export const CheckWrap = styled.span`
  ${fontCommonStyle}
  font-size: ${props => props.theme.fontSize.teritary};
  line-height: 1.5;
`;

export const IconWrap = styled.div`
  float: right;
  ${cursorPointer};
  margin-top: 23px;
  margin-right: -50px;
  i {
    font-size: 20px;
  }
  && .anticon-close {
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: 0;
    && .anticon-close {
      display: block;
    }
  }
`;

export const InfoContentWrapper = styled.div`
  padding: 0 6% 0 6%;
  position: fixed;
  background: ${props => props.theme.colors.white};
  width: 77%;
  height: 74.6%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
  @media only screen and (min-width: 790px) and (max-width: 976px) {
    height: 594px;
    width: 87.5%;
  }
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
`;

export const PopHeader = styled.div`
  font-family: BerkeleyStd-Bold;
  font-size: 24px;
  line-height: 1.17;
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  border-bottom: 2px solid #bfbfbf;
  padding: 30px 0 14px 0;
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
  margin-bottom: 24px;
`;

export const QASectionWrapperLast = styled(QASectionWrapper)`
  margin-bottom: 9px;
`;

export const QuestionWrap = styled.div`
  ${fontCommonStyle};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const QASection = styled.div`
  border-bottom: 2px solid #bfbfbf;
  height: 66.4%;
  overflow: scroll;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 60%;
  }
`;

export const AnswerWrap = styled.div`
  ${fontCommonStyle};
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 200px !important;
  height: 50px !important;
  border-radius: 0;
  font-family: HelveticaNeue-CondensedBlack;
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: 1.1px;
  ${cursorPointer}
  border: none;
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  margin-top: 30px;
`;

export const TitleMarginTop = styled.div`
  margin-top: 16px;
`;

export const TitleMarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const DeliveryMarginBottom = styled.div`
  margin-bottom: 20px;
`;

export const AddressWrap = styled.div`
  margin-bottom: -10px
`;

export const AdvisorMargin = styled.div`
  margin-bottom: 50px;
`;

export const SelectdropwownStyles = styled.div`
  .ant-select-dropdown {
    top: 40px !important;
    width: 90% !important;
  }
`;

export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: 40px;
    }
`;
export const WrapLabel = styled.div`
  &&& {
  .ant-form-item-label {
    margin-bottom: 10px;
  }
  &&& {
    .ant-form-item-label > label::after {
    margin: 0;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) { 
    &&& {
      .ant-form-item-label {
        padding: 0;
      }
    }
  }
`;

export const WebAccessInfoMargin = styled.div`
  .ant-form-item {
    margin-bottom: ${props => (props) ? props.marginBottom : "20px"}
    }
`;

export const AdressButtonMargin = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const DatePickerWrapper = styled.div`
  &&&
  {
    .ant-calendar {
      background: red;
      width: 327px;
    }
  }
`;

export const DividerWrap = styled.div`
  .ant-divider {
    background: #d4d4d4;
  }
`;

export const SubHeadingCode = styled.div`
  font-family: Typeface;
  font-size: 28px;
  line-height: 28px;
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 36px;
    width: 316px;
    height: 30px;
    line-height: 1.2;
    color: ${props => props.theme.fontColors.textColor};
  }
`;

export const SubHeadingContent = styled.div` 
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 24px;
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 36px;
    width: 316px;
    height: 30px;
    line-height: 1.2;
    color: ${props => props.theme.fontColors.textColor};
  } 
`;

export const HeadingWrapperInvite = styled.h1`
  font-family : ${props => props.theme.fontFamily.berkeleyStd}
  margin-top: 30px;
  letter-spacing : ${props => props.theme.letterSpacing.normal};
  font-size: ${props => props.theme.fontSize.h1};
  line-height : 1.14;
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    width: 316px;
    height: 84px;
    line-height: 1.2;
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const AccessDescription = styled.div`
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 24px;
  font-family: helveticaNeue;
`;

export const Description = styled.div`
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 24px;
  padding-top: 67px;
  margin-bottom: -5%;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    color: ${props => props.theme.fontColors.textColor};
    margin-top: 5%;
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 24px;
    padding-top: 10px;
    margin-bottom: -2%;
    font-family: helveticaNeue;
  }
`;

export const CheckboxWrappered = styled(CheckboxWrapper)`
  float:left;
  width:100;
  
`;

export const CheckboxContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: ${props => props.theme.fontColors.textColor};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.57;
    letter-spacing: normal;
  }
`;

export const AvatarFull = styled(Avatar)`
  background-color:#006778;
`;

export const AvatarRead = styled(Avatar)`
  background-color:#69923a;
`;

export const AvatarPaper = styled(Avatar)`
  background-color:#a8b400;
`;

export const RelativePositionDiv = styled.div`
  position: relative;
  width: 300px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width:100%;
  }
`;

export const InvitedHeading = styled.h1`
  font-family: ${ props => props.theme.fontFamily.berkeleyStd};
  width: 490px;
  font-size: ${ props => props.theme.fontSize.h1};
  line-height: ${ props => props.theme.lineHeight.h1};
  font-style: normal;
  font-stretch: normal;
  color: ${ props => props.theme.fontColors.headingColor};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${ props => props.theme.fontSize.h2};
    width: 316px;
    height: 84px;
    line-height: 1.2;
    color: ${ props => props.theme.fontColors.headingColor};
  }
`;

export const SuccessDesc = styled.p`
  color: ${props => props.theme.fontColors.textColor};
  line-height: 24px;
  padding-top: 15px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 30px;
  margin-right: 337px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size:  ${props => props.theme.fontSize.secondary};
    width: 316px;
    height: 30px;
    line-height: 1.2;
    color: ${props => props.theme.fontColors.textColor};
    margin-top: 21px;
    margin-bottom:50px;
  } 
`;

export const GhostButtonBack = styled(GhostButtonComponent)`
  width: 150px !important;
  height: 50px !important;
  color: ${props => props.theme.backgroundColor.primaryColor};
  margin-top: 49px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  letter-spacing: 0.5px;
  font-style: HelveticaNeue;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 50px 15px 10px 0;
    width:100% !important;
  }
  @media screen and (min-width:0\0) {
    width: 15%;
  }
`;

export const line = styled.div`
  width: 1159px;
  height: 1px;
  border: solid 1px #d4d4d4;  
`;



export const Authorizecheckbox = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  padding-left: 5px;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;

export const DropDownNoResult = styled.div`
  margin-left: 11px;  
  color: black;
`;

export const Namecheckbox = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  font-style: normal;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.57;
    font-size: ${props => props.theme.fontSize.secondary};
  }`
;

export const GhostButtonAccessLevel = styled(GhostButtonComponent)`
  ${InvitePartiesButton}
  color:  ${props => props.theme.backgroundColor.primaryColor};
  width: 150px;
  height: 50px;
  margin-top: 20px;
  box-shadow: 0 0 0 0.5px ${props => props.theme.border.teal};
  border: none;
  &:hover,
  :focus {
    border: none;
  }
`;

export const ButtonDividers = styled.div`
  .ant-divider {
    height: 0px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    height:1px;
    margin-top:22px;
    background: ${props => props.theme.colors.border};
    }
  }
`;

export const DescriptionParas = styled.p`
  font-family: ${ props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  padding-top: 0px;
  margin: 0px;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const ButtonDivider = styled.div`
  .ant-divider {   
    background : ${props => props.theme.colors.border}
    height: 1px;
    margin-top: 49.5px;
    @media only screen and (min-width : 320px) and (max-width : 767px) {
    height:1px;
    margin-top:110px;
    }
  }
`;

export const firstColumn = styled(Col)`
  border-right: none; 
  @media only screen and (max-width: 990px) {
    border-right: none;
  }
`;

export const AccesslevelHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
`;

export const Receivepaper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
`;

export const Title = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
  margin-top: 28px;
  margin-bottom: 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const InvitePartiesInput = styled(Input)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
  }
`;

export const InvitePartiesSelect = styled(Select)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 110% !important;
    .ant-select-selection--single {
      width: 97%;
  } 
  }
`;

export const InvitePartiesCalendar = styled(DatePicker)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-calendar-picker-input {
      width: 100% !important;
    }
  }
`;

export const InvitePartiesAccessLevel = styled.div`
  z-index: 1;
  .ant-radio-wrapper {
    display: block;
    height: 30px;
    lineHeight: ${props => props.theme.lineHeight.h4};  
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;

export const InvitePartiesFixedWidth = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
    width: 300px;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: 38px;
    vertical-align: middle;
    font-family: ${props => props.theme.fontFamily.helveticaNeue}
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
    div {
      font-size: ${props => props.theme.fontSize.primary};
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
  }
  .ant-select-selection__placeholder {
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.border};
    padding: 0 9px;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid #d4d4d4;
  }
  .ant-select-selection {
    box-shadow: none;
  }
  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }
  .ant-select-arrow {
    color: ${props => props.theme.fontColors.tbody};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.border.pill};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const InviteSelectBox = styled(CustomSelectBox)`
  .ant-select-selection-selected-value{    
    margin-top: 8px !important;
    @media(max-width: 767px){
      margin-top: 2px !important;
    }
  }
`;

export const TextWrapper = styled(InputWrapper)`
  @media(max-width: 767px) {
    width: 100%;
  }
`;

export const AccessCol = styled(Col)`
  && .ant-radio-wrapper {
    display: flex;
  }
  && .ant-radio-wrapper .ant-radio {
    margin-top: -3px;
  }
`;

export const TableLastData = styled.td`
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  text-align: right;
  padding: 8px 27px;
`;

export const TableRow = styled.tr`
  th {
    border-right: 1px solid ${props => props.theme.border.filledTabsInactive};
    border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
    text-align: center;
    padding: 4px;
    font-weight: ${props => props.theme.fontWeight.normal};
  }
`;